import { render } from "./ItemGroupCategoryDashboard.vue?vue&type=template&id=ecf3d58e&ts=true"
import script from "./ItemGroupCategoryDashboard.vue?vue&type=script&lang=ts"
export * from "./ItemGroupCategoryDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__